
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-name/[firstname_slug]",
      function () {
        return require("private-next-pages/first-name/[firstname_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-name/[firstname_slug]"])
      });
    }
  